import { useCallback } from 'react';

import { ShortUrl } from '@air/api';
import { type TaskType as RemoteTaskType } from '@air/api/types';

import { type TaskType as LocalTaskType } from '~/store/tasks/types';
import { type SharedSyncTasksParams, useSharedSyncTasks } from './useSharedSyncTasks';

type PublicSyncTasksParams<LocalType extends LocalTaskType, RemoteType extends RemoteTaskType> = {
  shortId: string;
} & Omit<SharedSyncTasksParams<LocalType, RemoteType>, 'getTask'>;

export const usePublicSyncTasks = <
  LocalType extends LocalTaskType = LocalTaskType,
  RemoteType extends RemoteTaskType = RemoteTaskType,
>({
  shortId,
  ...rest
}: PublicSyncTasksParams<LocalType, RemoteType>) => {
  const getTask = useCallback(
    (taskId: string) => {
      return ShortUrl.Tasks.getTask(shortId, { taskId });
    },
    [shortId],
  );

  return useSharedSyncTasks({
    ...rest,
    getTask,
  });
};
